module.exports = __webpack_public_path__ + "static/media/RRD2.4b1eeb87.jpg";